
    _ipgeolocation.enableSessionStorage(true);

    var ip = sessionStorage.getItem("ip");
    var country_name = sessionStorage.getItem("country_name");
    var continent_code = sessionStorage.getItem("continent_code");

    if (!ip || !country_name || !continent_code) {
        _ipgeolocation.makeAsyncCallsToAPI(false);
        _ipgeolocation.setFields("country_name,continent_code");
        _ipgeolocation.getGeolocation(handleResponse, "9ae6dc8981f94f9cb5bd077bc50ed71b");
    }
    
    function handleResponse(json) {
        ip = json.ip;
        country_name = json.country_name;
        continent_code = json.continent_code;
    }

    
    function isCrawler() {
      const bots = [
        /Googlebot/i,
        /Bingbot/i,
        /Slurp/i,
        /DuckDuckBot/i,
        /Baiduspider/i,
        /YandexBot/i,
        /Sogou/i,
        /Exabot/i,
        /facebot/i,
        /ia_archiver/i,
        /Twitterbot/i,
        /LinkedInBot/i
      ];

      const ua = navigator.userAgent || "";

      return bots.some(bot => bot.test(ua));
    }


    $(document).ready(function() {

      var dLCIP = [
        "87.242.245.202",
        "87.238.218.43",
        "87.238.218.73",
        "87.238.218.72",
        "141.0.145.55",
        "141.0.145.24",
        "87.238.218.70",
        "87.238.218.69",
        "185.159.219.134",
        "87.238.218.71",
        "216.187.42.152",
        "71.167.45.219"
      ];
      var dlc_UK = [
        "United Kingdom",
        "England",
        "Scotland",
        "Wales",
        "Isle of Man",
        "Northern Ireland",
        "Jersey",
        "Guernsey"
      ];
      var dlc_USA = [
        "United States"
      ];

      
      if (!isCrawler()) {
        
        if (!dLCIP.includes(ip)) {
          
          if (!dlc_USA.includes(country_name)) {
            
            if (dlc_UK.includes(country_name)) {
              url_redirect('delecuona.co.uk');
            }else{
              url_redirect('delecuona.eu');
            }
            
          }
          
        }
      
      }
        

        function setCookie(name,value,days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
          	//set the cookies for both websites
            document.cookie = name + "=" + (value || "")  + ";domain=usa.delecuona.com;" + expires + "; path=/";
          	document.cookie = name + "=" + (value || "")  + ";domain=delecuona.com;" + expires + "; path=/";
            document.cookie = name + "=" + (value || "")  + ";domain=delecuona.eu;" + expires + "; path=/";
            document.cookie = name + "=" + (value || "")  + ";domain=row.delecuona.com;" + expires + "; path=/";
        }
        function getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        }
        function eraseCookie(name) {   
            document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
        
        function url_redirect(domain){
            
            var old_url = window.location.href;
            var old_domain = window.location.hostname;
            var new_domain = domain;
        	location.replace(old_url.replace( new RegExp( old_domain, 'g' ), new_domain ));
            
        }
      
      });